import { MISSION_ENUM_TYPES } from '../../../shared/constants'
import { theme } from '../../../Assets/Styles/theme'
import locationIcon from '../../../Assets/Images/icons/new_location_icon.svg'

const GOOGLE_FORWARD_CLOSED_ARROW = 1
const GOOGLE_FORWARD_OPEN_ARROW = 2

export const getMissionZoneShapeProps = ({ id, boundary, boundaryColour }) => {
  if (!boundary || boundary.length <= 0) return
  return {
    key: id,
    path: boundary.map(path => ({
      lat: path.latitude,
      lng: path.longitude,
    })),
    options: {
      fillColor: boundaryColour,
      strokeColor: boundaryColour,
      fillOpacity: 0.3,
    },
  }
}

export const getMissionTypeSpecificProps = mission => {
  if (mission.type === MISSION_ENUM_TYPES.LETTERBOX) {
    return {
      pathColor: theme.colors.black,
      polygon: getMissionZoneShapeProps({
        id: mission.id,
        boundary: mission.boundary,
        boundaryColour: mission.boundaryColour,
      }),
      center: {
        lat: parseFloat(mission.boundary[0].latitude),
        lng: parseFloat(mission.boundary[0].longitude),
      },
    }
  }
  return {
    pathColor: theme.colors.red,
    center: {
      lat: parseFloat(
        (mission.checkInLocation && mission.checkInLocation.latitude) ||
          mission.location.latitude,
      ),
      lng: parseFloat(
        (mission.checkInLocation && mission.checkInLocation.longitude) ||
          mission.location.longitude,
      ),
    },
  }
}

export const getMissionMarkers = ({
  location,
  checkInLocation,
  checkInTime,
  checkoutTime,
  checkoutLocation,
  activities,
  currentLocation,
}) => {
  const CIRCLE = 0

  let markers = []

  if (location && location.latitude && location.longitude) {
    markers.push({
      position: {
        lat: parseFloat(location.latitude),
        lng: parseFloat(location.longitude),
      },
      options: {
        infoWindowSettings: {
          content: 'Mission Position',
        },
        icon: {
          url: locationIcon,
          scaledSize: {
            width: 50,
            height: 40,
          },
        },
      },
    })
  }

  if (checkInTime && checkInLocation) {
    markers.push({
      position: {
        lat: parseFloat(checkInLocation.latitude),
        lng: parseFloat(checkInLocation.longitude),
      },
      options: {
        infoWindowSettings: {
          content: 'Check In',
        },
        icon: {
          path: CIRCLE,
          scale: 8,
          strokeColor: theme.colors.forestGreen,
        },
      },
    })
  }

  if (checkoutTime && checkoutLocation) {
    markers.push({
      position: {
        lat: parseFloat(checkoutLocation.latitude),
        lng: parseFloat(checkoutLocation.longitude),
      },
      options: {
        infoWindowSettings: {
          content: 'Checkout',
        },
        icon: {
          path: CIRCLE,
          scale: 8,
          strokeColor: theme.colors.red,
        },
      },
    })
  }
  if (currentLocation) {
    markers.push({
      position: currentLocation,
      options: {
        infoWindowSettings: {
          content: 'Current Location',
        },
        icon: {
          path: CIRCLE,
          scale: 5,
          strokeColor: 'blue',
        },
      },
    })
  }
  return markers
}

export const getMissionPath = ({
  activities,
  checkInLocation,
  checkInTime,
  checkoutLocation,
  checkoutTime,
  pathColor,
}) => {
  let path = []

  if (
    checkInLocation &&
    checkInLocation.latitude &&
    checkInLocation.longitude
  ) {
    path = [
      {
        lat: parseFloat(checkInLocation.latitude),
        lng: parseFloat(checkInLocation.longitude),

        label: new Date(checkInTime).toLocaleTimeString(),
      },
    ]
  }

  path = [
    ...path,
    ...(activities || []).map(activityItem => {
      return {
        lat: parseFloat(activityItem.latitude),
        lng: parseFloat(activityItem.longitude),
        label: new Date(activityItem.datetime).toLocaleTimeString(),
      }
    }),
  ]

  if (
    checkoutLocation &&
    checkoutLocation.latitude &&
    checkoutLocation.longitude
  ) {
    path.push({
      lat: parseFloat(checkoutLocation.latitude),
      lng: parseFloat(checkoutLocation.longitude),
      label: new Date(checkoutTime).toLocaleTimeString(),
    })
  }

  return {
    path,
    options: {
      strokeColor: pathColor,
      strokeOpacity: 1.0,
      strokeWeight: 2,
      infoWindowSettings: {
        content: 'Movements Path',
      },
      icons: [
        {
          icon: {
            path: GOOGLE_FORWARD_OPEN_ARROW,
            scale: 1.5,
          },
          repeat: '70px',
          offset: '100%',
        },
        {
          icon: {
            path: GOOGLE_FORWARD_CLOSED_ARROW,
            strokeColor: '#F00',
            fillColor: '#fff',
            fillOpacity: 1,
            scale: 5,
          },
          offset: '100%',
        },
      ],
    },
  }
}



// WEBPACK FOOTER //
// ./src/Components/Missions/MissionMap/util.js